<!-- Glucose Insights Card -->
<div class="glucose-insight-card">
  <div class="glucose-insight-header">
    <h3 class="glucose-insight-title">Create Insights for the Date Selected in Above Date Picker</h3>
    <button type="button" class="generate-insight-btn" [class.generated]="insightGenerated"
      [disabled]="isGeneratingInsight" (click)="onGenerateInsight()">
      {{ isGeneratingInsight ? 'Generating...' : (insightGenerated ? 'View Insight' : 'Generate Insight') }}
    </button>
  </div>
</div>

<!-- <mat-checkbox >Post meal</mat-checkbox> &nbsp;<mat-checkbox >Fasting</mat-checkbox> -->
<div style="width: 90%; padding: 0; margin: 0; position: relative; min-height: 300px;">
  <highcharts-chart *ngIf="showChart" #chart [Highcharts]="Highcharts" [options]="chartOptions"
    style="width: 100%; height: 100%; display: block;"></highcharts-chart>
  <div *ngIf="noDataFound"
    style="position: absolute; top: 50%; left: 0; width: 100%; text-align: center; transform: translateY(-50%); pointer-events: none;">
    <h6 style="color: gray;">No Record found for selected date range</h6>
  </div>
</div>

<app-glucose-value [details]="glucoseDetails"></app-glucose-value>

<div class="modal fade" id="exampleModalCenter" tabindex="-1" role="dialog" aria-labelledby="exampleModalCenterTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content gmodalcontent">
      <div class="modal-header">
        <img src={{modalImg}} height="8%" width="8%"> &nbsp;&nbsp;<h5 class="modal-title mtitle"
          id="exampleModalLongTitle">{{modalType}}</h5>
        <p *ngIf="modalType === 'Sleep'" class="spmodal">{{modalSTime}} - {{modalETime}}</p>
        <p *ngIf="modalType !== 'Sleep'" class="pmodal">{{modalSTime}}</p>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row smtitle" *ngIf="modalType == 'Sleep'">
          Total Sleep Duration
        </div>
        <div class="row smbody" *ngIf="modalType == 'Sleep'">
          {{modalDuration}}
        </div>
        <div class="row smtitle" *ngIf="modalType == 'Activity'">
          <div class="col-md-4">
            Activity Name
          </div>
          <div class="col-md-4">
            Calories Burned
          </div>
          <div class="col-md-4">
            Distance Covered
          </div>
        </div>
        <div class="row smbody" *ngIf="modalType == 'Activity'">
          <div class="col-md-4">
            {{activityName}}
          </div>
          <div class="col-md-4">
            {{calsBurned}} kcal
          </div>
          <div class="col-md-4">
            {{distCovered}} {{distUnits}}
          </div>
        </div>

        <div class="row fmname" *ngIf="modalType == 'Nutrition'">
          {{foodName}}
        </div>
        <div class="row fmtitle" *ngIf="modalType == 'Nutrition'">
          <div class="col-md-3">
            <img src="/assets/img/calories.png" width="12%" height="80%" /> &nbsp;Calories
          </div>
          <div class="col-md-3">
            <img src="/assets/img/protien.png" width="14%" height="83%" /> &nbsp;Proteins
          </div>
          <div class="col-md-3">
            <img src="/assets/img/carbs.png" width="13%" height="82%" /> &nbsp;Carbs
          </div>
          <div class="col-md-3">
            <img src="/assets/img/fat.png" width="17%" height="86%" /> &nbsp;Fats
          </div>
        </div>
        <div class="row smbody" *ngIf="modalType == 'Nutrition'">
          <div class="col-md-3">
            {{foodCals}} cal
          </div>
          <div class="col-md-3">
            {{foodProteins}} grams
          </div>
          <div class="col-md-3">
            {{foodCarbs}} grams
          </div>
          <div class="col-md-3">
            {{foodFats}} grams
          </div>
        </div>

        <!-- Medication section -->
        <div class="row fmname" *ngIf="modalType == 'Medication'">
          {{medicName}}
        </div>
        <div class="row fmtitle" *ngIf="modalType == 'Medication'">
          <div class="col-md-4">
            <img src="/assets/img/medicine.png" width="12%" height="80%" /> &nbsp;Dosage
          </div>
          <div class="col-md-4">
            Quantity
          </div>
          <div class="col-md-4">
            Frequency
          </div>
        </div>
        <div class="row smbody" *ngIf="modalType == 'Medication'">
          <div class="col-md-4">
            {{medicDosage}}
          </div>
          <div class="col-md-4">
            {{medicQuantity}}
          </div>
          <div class="col-md-4">
            {{medicFrequency}}
          </div>
        </div>
      </div>
      <br />
      <br />
    </div>
  </div>
</div>

<!-- <div class="col-md-4 float ">
    <div class="noteSection">Notes Section</div>
    <app-notes></app-notes>
</div> -->

<!-- Generate Insight response modal -->
<div class="modal fade" id="glucoseInsightModal" tabindex="-1" role="dialog" aria-labelledby="glucoseInsightModalTitle"
  aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
    <div class="modal-content gmodalcontent">
      <div class="modal-header">
        <h5 class="modal-title glucose-insight-modal-title" id="glucoseInsightModalTitle">Insights</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeInsightModal()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body glucose-insight-body" [innerHTML]="getChatMessageHtml(insightText)"></div>
    </div>
  </div>
</div>

<div class="glucoseChatWrapper">
  <div class="glucoseChatPanel" *ngIf="showHideChatBot">
    <div class="glucoseChatHeader">
      <label class="glucoseChatTitle">GlycoBrain</label>
      <img width="16" (click)="hideChatBot()" src="assets/img/close.png" class="glucoseChatClose" />
    </div>

    <div class="glucoseChatMessages">
      <div class="glucoseChatConnecting" *ngIf="!chatReady && isSending">Connecting to GlycoBrain...</div>
      <div *ngFor="let message of messages" class="glucoseChatMessage" [ngClass]="{ 'user': message.sender === 'user', 'bot': message.sender !== 'user' }">
        <div class="glucoseChatBubble">
          <strong class="glucoseChatName">{{ message.sender === 'user' ? 'You' : 'GlycoBrain' }}</strong>
          <div class="glucoseChatText" id="{{message.id}}" *ngIf="message.sender === 'user'">{{ message.text }}</div>
          <div class="glucoseChatText" id="{{message.id}}" *ngIf="message.sender !== 'user'" [innerHTML]="getChatMessageHtml(message.text)"></div>
        </div>
      </div>
    </div>

    <div class="glucoseChatInputRow">
      <input type="text" [(ngModel)]="userMessage" (keyup.enter)="sendMessage()" [disabled]="isSending || !chatReady"
        class="form-control glucoseChatInput" placeholder="Ask about this member's glucose data" />
      <button type="button" class="glucoseChatSendBtn" [disabled]="!userMessage.trim() || isSending || !chatReady" (click)="sendMessage()">
        <img width="32" src="assets/img/send.png" class="glucoseChatSend" />
      </button>
      <!-- [disabled]="!lastResponseMessage || isGeneratingMessage || isSending" -->
      <button type="button" class="glucoseGenerateMsgBtn" (click)="generateSummaryMessage()"
        [title]="isGeneratingMessage ? 'Generating message...' : 'Generate message'">
        <i class="fa" [ngClass]="isGeneratingMessage ? 'fa-spinner fa-spin' : 'fa-magic'"></i>
      </button>
    </div>

    <div class="insightPickerSection" *ngIf="showInsightPicker">
      <label class="rallyMessageTitle">Select insights to generate the message from</label>
      <div class="insightPickerOptions">
        <label class="insightPickerOption" *ngFor="let insight of summaryInsights">
          <input type="checkbox" [(ngModel)]="insight.selected" /> Insight {{ insight.number }}<ng-container *ngIf="insight.section"> ({{ insight.section }})</ng-container>
        </label>
      </div>
      <div class="archetypeSection">
        <label class="archetypeLabel">Archetype</label>
        <div class="archetypeDropdown">
          <button type="button" class="form-control archetypeDropdownToggle" (click)="showArchetypeDropdown = !showArchetypeDropdown">
            <span>{{ archetypeDropdownLabel }}</span>
            <i class="fa" [ngClass]="showArchetypeDropdown ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
          </button>
          <div class="archetypeDropdownMenu" *ngIf="showArchetypeDropdown">
            <div class="archetypeOption" *ngFor="let archetype of archetypes" [class.selected]="archetype.selected"
              (click)="toggleArchetype(archetype)">
              {{ archetype.name }}
            </div>
          </div>
        </div>
        <button type="button" class="glucoseGenerateMsgBtn" (click)="generateFromSelectedInsights()"
          [disabled]="!hasSelectedInsights || isGeneratingMessage || isSending" title="Generate message from selected insights">
          <i class="fa fa-magic"></i>
        </button>
      </div>
    </div>

    <div class="rallyMessageSection" *ngIf="showRallyMessageBox">
      <div class="rallyDeliveredNotice" *ngIf="rallyDelivered">
        <i class="fa fa-check-circle"></i> Message has been delivered to member through Renee
      </div>
      <ng-container *ngIf="!rallyDelivered">
      <label class="rallyMessageTitle">Message to send member through Renee</label>
      <div class="rallyMessageRow">
        <textarea class="form-control rallyMessageInput" rows="4" [(ngModel)]="rallyMessage"
          [disabled]="isGeneratingMessage || isSendingRallyMessage"
          [placeholder]="isGeneratingMessage ? 'Generating message...' : 'Message to send to the member'"></textarea>
        <button type="button" class="rallyMessageSendBtn" (click)="sendRallyMessage()"
          [disabled]="!rallyMessage.trim() || isGeneratingMessage || isSendingRallyMessage"
          [title]="isSendingRallyMessage ? 'Sending...' : 'Send to member'">
          <i class="fa" [ngClass]="isSendingRallyMessage ? 'fa-spinner fa-spin' : 'fa-paper-plane'"></i>
        </button>
      </div>
      <div class="rallyMessageStatus" *ngIf="rallySendStatus" [class.error]="!rallySendStatus.success">
        {{ rallySendStatus.text }}
      </div>
      </ng-container>
    </div>
  </div>

  <img class="glucoseChatBtn" width="72" (click)="openChatBot()" src="assets/img/ai.png" />
</div>